export default {
  sm: `
  네이버에 새겨진 데이터를 안전하게
  저장하고 있는 데이터센터 각은 미래 산업에
  지속성 있는 가치를 제공하고자
  노력하고 있습니다.
  `,
  lg: `
  네이버에 새겨진 데이터를 안전하게 저장하고 있는 
  데이터센터 각은 미래 산업에 지속성 있는 가치를
  제공하고자 노력하고 있습니다.
  `,
  xxl: `
  네이버에 새겨진 데이터를 안전하게 저장하고 있는 데이터센터 각은
  미래 산업에 지속성 있는 가치를 제공하고자 노력하고 있습니다.
  `
};
